
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule, provideServiceWorker } from '@angular/service-worker';
import { isDevMode, importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import {provideTranslateService, provideTranslateLoader} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { environment } from './environments/environment';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';

bootstrapApplication(AppComponent, {
	providers: [
		provideIonicAngular(),

		importProvidersFrom(
			BrowserModule,
			IonicModule.forRoot(),
			AppRoutingModule,
			ServiceWorkerModule.register('ngsw-worker.js', {
				enabled: !isDevMode(),
				registrationStrategy: 'registerWhenStable:30000'
			})
		),
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		provideHttpClient(withInterceptors([authInterceptor])),
		provideTranslateService({
			loader: provideTranslateHttpLoader({
				prefix: '/assets/i18n/',
				suffix: '.json'
			}),
			fallbackLang: 'es',
			lang: 'es'
		}),
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000'
		}),
		provideFirebaseApp(() => initializeApp(
			environment.firebase
		)),
		provideFirestore(() => getFirestore()),
		provideStorage(() => getStorage()),
		provideAuth(() => getAuth())
	]
}).catch(err => console.error(err));
